// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dEs4QGQJdh8fJQuy12t6{background-color:var(--background-primary-inverted-disabled);border-radius:4px;justify-content:center;align-items:center;width:18px;height:16px;display:flex}.MCaeZBH_Ok5CxuPeSMbC{justify-content:center;align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hotKey": `dEs4QGQJdh8fJQuy12t6`,
	"labelWrapper": `MCaeZBH_Ok5CxuPeSMbC`
};
export default ___CSS_LOADER_EXPORT___;
